import React from 'react'
import Header from '@cloudscape-design/components-themed/header'

// https://cloudscape.design/components/header
export function RadHeader ({ ...rest }) {
  return (
    <Header {...rest} />
  )
}
